<template>
  <footer
    class="footer__wrapper"
    v-observe-visibility="footerVisibilityOptions"
  >
    <div class="footer__content-wrapper">
      <div class="footer__main-content-wrapper">
        <div class="footer__main-content">
          <div class="footer__menu-list-wrapper">
            <footer-logo class="footer__logo" />
            <div class="footer__menu-list">
              <footer-menu-list :items="footerLeftSection" />
              <footer-menu-list :items="footerRightSection" />
            </div>
          </div>
          <footer-newsletter-form />
          <footer-follow-us-section :footer-socials="stayConnected" />
        </div>
        <div class="footer-horizontal-divider"></div>
        <footer-bottom-text />
      </div>
    </div>
  </footer>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

import FooterLogo from './FooterLogo'
import FooterNewsletterForm from './FooterNewsletterForm'
import FooterFollowUsSection from './FooterFollowUsSection'
import FooterBottomText from './FooterBottomText'
import { serverCacheKey } from '@/utils/mixins/serverCacheKey'
import { hydrateWhenVisible } from '@/utils/helpers/vue-lazy-hydration/LazyHydrate'
import { OBSERVER_CALLBACK_DEFAULT_THROTTLE } from 'enums/mutation-observer'
import * as types from '@/store/mutation-types'

export default {
  name: 'Footer',
  mixins: [serverCacheKey],
  components: {
    FooterLogo,
    FooterMenuList: hydrateWhenVisible(() => import('./FooterMenuList'), {
      props: ['items']
    }),
    FooterNewsletterForm,
    FooterFollowUsSection,
    FooterBottomText
  },
  data() {
    return {
      footerVisibilityOptions: {
        callback: this.setFooterVisibilityState,
        throttle: OBSERVER_CALLBACK_DEFAULT_THROTTLE
      }
    }
  },
  computed: {
    ...mapGetters({
      footerLeftSection: 'footerLeftSection',
      footerRightSection: 'footerRightSection',
      stayConnected: 'stayConnected'
    })
  },
  methods: {
    ...mapMutations({
      setFooterVisibilityState: `element-visibility/${types.SET_FOOTER_VISIBILITY_STATE}`
    })
  }
}
</script>

<style lang="scss" scoped>
.footer__wrapper {
  width: 100%;
  background: radial-gradient(
    100.91% 53.73% at 50% -10.14%,
    $c--main 0%,
    $c--black 100%
  );
  color: $c--white;
  margin-top: 20px;
  padding: 64px 60px;

  @include tablet {
    padding: 24px;
  }

  @include mobile {
    padding: 36px 24px 64px;
  }

  .footer__content-wrapper {
    display: flex;
    max-width: $desktop-full-hd-container;
    margin: 0 auto;
  }

  .footer__main-content {
    display: flex;
    justify-content: space-between;

    & > *:not(:last-child) {
      margin-right: 40px;
    }

    @include tablet {
      & > *:not(:last-child) {
        margin-right: 24px;
      }
    }
    @include mobile {
      flex-direction: column;

      & > *:not(:last-child) {
        margin-right: 0;
        margin-bottom: 24px;
      }
    }
  }

  .footer__menu-list {
    margin-top: 24px;
    display: flex;

    & > *:not(:last-child) {
      margin-right: 40px;
    }

    @include tablet {
      & > *:not(:last-child) {
        margin-right: 24px;
      }
    }
  }
}
</style>

<style lang="scss">
.premium-page .footer__wrapper {
  background: $c--black;
}
</style>
